import { r as registerInstance, h } from './core-39f715ab.js';
var RaulBreadcrumbBackIcon = /** @class */ (function () {
    function RaulBreadcrumbBackIcon(hostRef) {
        registerInstance(this, hostRef);
    }
    RaulBreadcrumbBackIcon.prototype.render = function () {
        return (h("raul-icon", { icon: "arrow-left-1" }));
    };
    Object.defineProperty(RaulBreadcrumbBackIcon, "style", {
        get: function () { return "raul-breadcrumb-back-icon{display:-ms-inline-flexbox;display:inline-flex;font-size:1.25rem;padding-right:.5rem}"; },
        enumerable: true,
        configurable: true
    });
    return RaulBreadcrumbBackIcon;
}());
export { RaulBreadcrumbBackIcon as raul_breadcrumb_back_icon };
